export default {
	name: 'end',
	description: 'Окно завершения игры',
	title: 'Подведение итогов',
	minigameType: 'End',
	generateParams(minigame, state) {
		return { history: state.objects.history };
	},
	isCompleted: () => true,
	score: 0,
};